export const FIELDSETS = {
  PERSON_INFORMATION: 'personInformation',
  AFFILIATION: 'personAffiliation',
  CONTACT_DATA: 'personContactData',
  TERMS_OF_SERVICE_AND_PRIVACY_POLICY: 'termsOfServiceAndPrivacyPolicy',
} as const;

export const REGISTRATION_TYPE = {
  selfRegistration: 'selfRegistration',
  teamroomInvitation: 'teamroomInvitation',
} as const;

export const AUTOCOMPLETE_VALUES = {
  honorificPrefix: 'honorific-prefix',
  academicTitle: 'honorific-suffix',
  firstName: 'given-name',
  lastName: 'family-name',
  institution: 'organization',
  phoneAreaCode: 'tel-area-code',
  phonePrefix: 'tel-local',
  phoneLineNumber: 'tel-extension',
  emailAddress: 'email',
} as const;
